import { render, staticRenderFns } from "./ManagePartnersAdmin.vue?vue&type=template&id=223c4d95&scoped=true"
import script from "./ManagePartnersAdmin.vue?vue&type=script&lang=js"
export * from "./ManagePartnersAdmin.vue?vue&type=script&lang=js"
import style0 from "./ManagePartnersAdmin.vue?vue&type=style&index=0&id=223c4d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c4d95",
  null
  
)

export default component.exports